import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import Home from "./pages/Home";
import About from "./pages/About";
import Containers from "./pages/Containers";
import ContainerDetails from "./pages/ContainerDetails";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Search from "./pages/Search";
import Track from "./pages/Track";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ReturnRefundPolicy from "./pages/ReturnRefundPolicy";
import NewContainers from "./pages/services/NewContainers";
import UsedContainers from "./pages/services/UsedContainers";
import CustomModifications from "./pages/services/CustomModifications";
import MobileOffices from "./pages/services/MobileOffices";
import NationwideDelivery from "./pages/services/NationwideDelivery";
import ContainerStorageSolutions from "./pages/services/ContainerStorageSolutions";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200); // Show loader for 1.2 seconds

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && (
        <Loader message="Loading..." subtext="Preparing your content" />
      )}
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/containers" element={<Containers />} />
            <Route path="/containers/:id" element={<ContainerDetails />} />
            <Route path="/services" element={<Services />} />
            <Route path="/search" element={<Search />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/track" element={<Track />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route
              path="/return-refund-policy"
              element={<ReturnRefundPolicy />}
            />
            <Route
              path="/services/new-containers"
              element={<NewContainers />}
            />
            <Route
              path="/services/used-containers"
              element={<UsedContainers />}
            />
            <Route
              path="/services/custom-modifications"
              element={<CustomModifications />}
            />
            <Route
              path="/services/mobile-offices"
              element={<MobileOffices />}
            />
            <Route
              path="/services/nationwide-delivery"
              element={<NationwideDelivery />}
            />
            <Route
              path="/services/container-storage-solutions"
              element={<ContainerStorageSolutions />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </CartProvider>
  );
}

export default App;
